import { ArrowUpRight, BookOpen, Blocks, GraduationCap, NotebookPen, Award, MessagesSquare, AudioLines, Croissant } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const IMG_BOOKS =
  "https://images.unsplash.com/photo-1692742593528-ad97f591ff3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHx2aW50YWdlJTIwZnJlbmNoJTIwYm9va3N8ZW58MHx8fHwxNzg5MDA0MzY5fDA&ixlib=rb-4.1.0&q=85";
const IMG_CAFE =
  "https://images.unsplash.com/photo-1658829457670-d80231baebe5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxwYXJpc2lhbiUyMGNhZmUlMjBhZXN0aGV0aWN8ZW58MHx8fHwxNzg5MDA0MzY5fDA&ixlib=rb-4.1.0&q=85";

const SERVICES = [
  {
    n: "01", icon: BookOpen, title: "French as a Foreign Language", sub: "FLE — all levels",
    text: "Structured lessons from complete beginner to advanced, following the CEFR framework.",
    span: "lg:col-span-2", img: IMG_BOOKS, testid: "service-fle",
  },
  {
    n: "02", icon: Blocks, title: "French for Children", sub: "Young learners",
    text: "Playful, personalized learning: songs, games and stories to fall in love with French.",
    testid: "service-children",
  },
  {
    n: "03", icon: GraduationCap, title: "Tutoring for Teens", sub: "Middle & high school",
    text: "Individualized support to succeed at school and build confidence in speaking and writing.",
    testid: "service-teens",
  },
  {
    n: "04", icon: NotebookPen, title: "AP French Preparation", sub: "Exam coaching",
    text: "Targeted coaching and focused practice to approach the AP French exam with confidence.",
    testid: "service-ap",
  },
  {
    n: "05", icon: Award, title: "TEF / TCF Preparation", sub: "Official exams",
    text: "Focused preparation for the TEF and TCF exams: strategies, mock tests and detailed feedback.",
    testid: "service-tef",
  },
  {
    n: "06", icon: MessagesSquare, title: "French Conversation", sub: "Fluency & confidence",
    text: "Personalized practice to improve your fluency, grow your vocabulary and speak with ease.",
    span: "lg:col-span-2", testid: "service-conversation",
  },
  {
    n: "07", icon: AudioLines, title: "Pronunciation Coaching", sub: "Accent & rhythm",
    text: "Refine the sounds, accent, rhythm and melody of French to speak with confidence.",
    testid: "service-pronunciation",
  },
  {
    n: "08", icon: Croissant, title: "Culture & Etiquette", sub: "The French art of living",
    text: "Customs, social codes and everyday communication: understand France from the inside.",
    span: "lg:col-span-2", img: IMG_CAFE, testid: "service-culture",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 lg:py-36 bg-ivory/40" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <Eyebrow>Eight specialties</Eyebrow>
          <div className="flex flex-wrap items-end justify-between gap-6 mt-6">
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight max-w-xl">
              Lessons at <span className="italic text-gold">the Atelier</span>
            </h2>
            <p className="text-navy/60 max-w-sm text-sm leading-relaxed">
              Eight specialties, one common thread: individual, demanding
              and encouraging instruction.
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 border-t border-l border-sand" data-testid="services-grid">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.n} delay={(i % 4) * 0.08} className={`${s.span || ""} border-r border-b border-sand`}>
                <article className="service-cell group relative h-full p-8 lg:p-10 flex flex-col min-h-[280px]" data-testid={s.testid}>
                  {s.img && (
                    <div className="overflow-hidden mb-6 aspect-[16/7]">
                      <img
                        src={s.img}
                        alt={s.title}
                        loading="lazy"
                        className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                      />
                    </div>
                  )}
                  <div className="flex items-start justify-between">
                    <span className="text-xs tracking-[0.3em] text-gold">{s.n}</span>
                    <ArrowUpRight size={18} className="service-arrow text-navy/40" />
                  </div>
                  <Icon size={22} strokeWidth={1.5} className="mt-5 text-gold" />
                  <h3 className="font-serif text-2xl mt-4">{s.title}</h3>
                  <p className="text-xs uppercase tracking-[0.25em] text-navy/50 mt-1">{s.sub}</p>
                  <p className="text-sm text-navy/70 leading-relaxed mt-4">{s.text}</p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
